import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemaHelperService {
  private temas!: Tema[];
  private temaAtivo!: Tema;
  public indexAtual = 1;

  public setTemas(temasInput: Tema[]){
    this.temas = temasInput;
  }

  public trocarTema(): void {
    this.indexAtual = this.temaAtivo ? this.temas.findIndex(x => x == this.temaAtivo) : 0;
    if( (this.indexAtual + 1) == this.temas.length )
      this.temaAtivo = this.temas[0];
    else
      this.temaAtivo = this.temas[this.indexAtual+1];

    Object.keys(this.temaAtivo.propriedades).forEach(p => {
      document.documentElement.style.setProperty(
        p,
        this.temaAtivo.propriedades[p]
      );
    });
  }

  public temaPadraoAtivo() : boolean {
    return this.indexAtual === 1;
  }
}

export interface Tema {
  nome: string;
  propriedades: Record<string, string>;
}
